/* RESPONSIBLE TEAM: team-phone */
import type AppService from 'embercom/services/app-service';
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import { dropTask } from 'ember-concurrency-decorators';
import { get } from 'embercom/lib/ajax';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import type CallingUsageData from 'embercom/models/calling-usage-data';

export default class PhoneUsagesRoute extends WorkspaceSettingsRoute {
  @service declare intl: IntlService;
  @service declare appService: AppService;

  get titleToken() {
    return this.intl.t('billing.usage.phone.title');
  }

  async model() {
    let usages = await taskFor(this.fetchCallingUsageTask).perform();
    return usages;
  }

  @dropTask
  *fetchCallingUsageTask(): TaskGenerator<CallingUsageData | null> {
    try {
      let response = yield get(`/ember/calling_usages`, {
        app_id: this.appService.app.id,
      });

      return response;
    } catch (error) {
      console.error('Error fetching calling usage:', error);
      return null;
    }
  }
}
